module.exports = __webpack_public_path__ + "img/emptypng.3c27cc34.png";